{
  "404": "404",
  "(Click on the document to view it in fullscreen mode)": "(Click on the document to view it in fullscreen mode)",
  "ACH details will be displayed here.": "ACH details will be displayed here.",
  "About autosave": "About autosave",
  "Accept & Continue": "Accept & Continue",
  "Add ACH on File": "Add ACH on File",
  "Add Card on File": "Add Card on File",
  "Add Image": "Add Image",
  "Add More": "Add More",
  "Add Signature": "Add Signature",
  "Are you sure you want to leave? Your changes will be lost.": "Are you sure you want to leave? Your changes will be lost.",
  "Auto-fill Form": "Auto-fill Form",
  "Auto-fill requires you to verify your identity by obtaining a verification code at your registered email address or phone number. By selecting auto-fill, you consent to receiving a text message and email with your verification code. Message & data rates may apply.": "Auto-fill requires you to verify your identity by obtaining a verification code at your registered email address or phone number. By selecting auto-fill, you consent to receiving a text message and email with your verification code. Message & data rates may apply.",
  "Autosave is unavailable. Keep this page open until you submit.": "Autosave is unavailable. Keep this page open until you submit.",
  "Autosave paused. Recent changes aren't saved.": "Autosave paused. Recent changes aren't saved.",
  "Bank account": "Bank account",
  "By clicking eSign, you confirm and agree that you have thoroughly reviewed the contents of the documents you are about to sign electronically. Any method you choose here to eSign is legally binding and you are ultimately responsible for its implications.": "By clicking eSign, you confirm and agree that you have thoroughly reviewed the contents of the documents you are about to sign electronically. Any method you choose here to eSign is legally binding and you are ultimately responsible for its implications.",
  "Canada": "Canada",
  "Cancel": "Cancel",
  "Card": "Card",
  "Card Number": "Card Number",
  "Card details will be displayed here.": "Card details will be displayed here.",
  "Cardholder Name": "Cardholder Name",
  "Changes not saved yet": "Changes not saved yet",
  "Checking for saved progress…": "Checking for saved progress…",
  "Child": "Child",
  "Choose the forms below to begin entering information and submit": "Choose the forms below to begin entering information and submit",
  "City": "City",
  "Clear": "Clear",
  "Clear Signature": "Clear Signature",
  "Click/Tap inside this box to sign": "Click/Tap inside this box to sign",
  "Close": "Close",
  "Code verified successfully": "Code verified successfully",
  "Company Logo": "Company Logo",
  "Complete the following fields": "Complete the following fields",
  "Complete the following fields (required by HIPAA)": "Complete the following fields (required by HIPAA)",
  "Complete the following fields (required by HIPAA) to securely verify your identity": "Complete the following fields (required by HIPAA) to securely verify your identity",
  "Continue": "Continue",
  "Couldn't save. Retrying…": "Couldn't save. Retrying…",
  "Country": "Country",
  "Date of Birth": "Date of Birth",
  "Date of birth": "Date of birth",
  "Date: {{timestamp}}": "Date: {{timestamp}}",
  "Dependent": "Dependent",
  "Didn't receive the code?": "Didn't receive the code?",
  "Digitally signed by {{name}}": "Digitally signed by {{name}}",
  "Discard and start fresh": "Discard and start fresh",
  "Discard saved progress?": "Discard saved progress?",
  "Dismiss": "Dismiss",
  "Do you want to extend this session or return to Kiosk?": "Do you want to extend this session or return to Kiosk?",
  "Document": "Document",
  "Document preview": "Document preview",
  "Document text alternative": "Document text alternative",
  "Don't have access to your phone or email?": "Don't have access to your phone or email?",
  "Download Now": "Download Now",
  "Download time for your submission has expired": "Download time for your submission has expired",
  "Draft saved": "Draft saved",
  "Drag it to the signature field": "Drag it to the signature field",
  "Drag your signature onto the signature line in the document.": "Drag your signature onto the signature line in the document.",
  "Draw": "Draw",
  "Draw your signature": "Draw your signature",
  "Driver's License Number": "Driver's License Number",
  "Edit": "Edit",
  "Edit Signature": "Edit Signature",
  "Electronically sign document": "Electronically sign document",
  "Email": "Email",
  "Email Address": "Email Address",
  "Empty {{type}} section": "Empty {{type}} section",
  "English": "English",
  "Enter the following information to continue": "Enter the following information to continue",
  "Enter the last 4 digits of your phone number": "Enter the last 4 digits of your phone number",
  "Enter your Full Name": "Enter your Full Name",
  "Existing Patient": "Existing Patient",
  "Expires {{expiry}}": "Expires {{expiry}}",
  "Expiry": "Expiry",
  "Failed to generate the PDF!": "Failed to generate the PDF!",
  "Failed to load signature": "Failed to load signature",
  "Failed to send verification code. Please fill out form manually if problem persists.": "Failed to send verification code. Please fill out form manually if problem persists.",
  "Failed to upload signature. Please try again.": "Failed to upload signature. Please try again.",
  "Failed to upload the signed document. Please try again.": "Failed to upload the signed document. Please try again.",
  "Failed to verify code. Please fill out form manually if problem persists.": "Failed to verify code. Please fill out form manually if problem persists.",
  "File exceeds the {{limit}} limit": "File exceeds the {{limit}} limit",
  "File type not allowed. Accepted: {{types}}": "File type not allowed. Accepted: {{types}}",
  "Fill out Manually": "Fill out Manually",
  "Fill out manually": "Fill out manually",
  "Finish & Sign": "Finish & Sign",
  "First Name": "First Name",
  "For Office Use Only": "For Office Use Only",
  "Form progress": "Form progress",
  "Forms": "Forms",
  "Forms_one": "Forms",
  "Forms_other": "Forms",
  "Full name": "Full name",
  "Gender": "Gender",
  "Group Name": "Group Name",
  "Group No": "Group No",
  "HIPAA Compliance": "HIPAA Compliance",
  "Home Phone": "Home Phone",
  "I'm done": "I'm done",
  "If you need assistance, please reach out to {{officeName}}.": "If you need assistance, please reach out to {{officeName}}.",
  "Invalid file": "Invalid file",
  "Keep draft": "Keep draft",
  "Kiosk Image": "Kiosk Image",
  "Last 4 digits of your registered phone number": "Last 4 digits of your registered phone number",
  "Last Name": "Last Name",
  "Leave anyway": "Leave anyway",
  "Leave this page?": "Leave this page?",
  "Leave without saving recent changes": "Leave without saving recent changes",
  "Loading ACH details...": "Loading ACH details...",
  "Loading card details...": "Loading card details...",
  "Loading document text...": "Loading document text...",
  "Loading document...": "Loading document...",
  "Loading signature...": "Loading signature...",
  "Make signature larger": "Make signature larger",
  "Make signature smaller": "Make signature smaller",
  "Marital Status": "Marital Status",
  "Max file size: 12MB": "Max file size: 12MB",
  "Max {{limit}} images allowed": "Max {{limit}} images allowed",
  "Maximum size allowed for each file is {{size}} MB": "Maximum size allowed for each file is {{size}} MB",
  "Member ID": "Member ID",
  "Middle Name": "Middle Name",
  "Min": "Min",
  "Missing location or submission information for PDF generation!": "Missing location or submission information for PDF generation!",
  "Mobile Phone": "Mobile Phone",
  "New Patient": "New Patient",
  "Next": "Next",
  "No": "No",
  "No ACH added!": "No ACH added!",
  "No Signatures Added": "No Signatures Added",
  "No card added!": "No card added!",
  "No code received.": "No code received.",
  "No document attached.": "No document attached.",
  "No matching results found!": "No matching results found!",
  "No privacy policy found": "No privacy policy found",
  "No readable text is available for this page.": "No readable text is available for this page.",
  "No results found": "No results found",
  "No terms & conditions found": "No terms & conditions found",
  "No {{type}} listed": "No {{type}} listed",
  "No: return to Kiosk": "No: return to Kiosk",
  "OR": "OR",
  "OTP digit {{index}} of {{length}}": "OTP digit {{index}} of {{length}}",
  "Other": "Other",
  "Our office is experiencing some technical difficulties right now. Please contact our office to proceed further.": "Our office is experiencing some technical difficulties right now. Please contact our office to proceed further.",
  "PDF download expired": "PDF download expired",
  "Packets": "Packets",
  "Page {{current}} of {{total}}": "Page {{current}} of {{total}}",
  "Page {{page}} of {{total}}": "Page {{page}} of {{total}}",
  "Patient Information": "Patient Information",
  "Payer ID": "Payer ID",
  "Payer Name": "Payer Name",
  "Payer Name is required": "Payer Name is required",
  "Picture of {{type}}": "Picture of {{type}}",
  "Pinned": "Pinned",
  "Please add your ACH details to proceed further": "Please add your ACH details to proceed further",
  "Please add your card details to proceed further": "Please add your card details to proceed further",
  "Please attach the required image(s)": "Please attach the required image(s)",
  "Please contact the business if you have any questions.": "Please contact the business if you have any questions.",
  "Please enter a valid code": "Please enter a valid code",
  "Please only complete this form on a trusted device. If you're using a public device, please use caution when entering sensitive or personal information. Always close your browser window and permanently delete any file downloads when finished.": "Please only complete this form on a trusted device. If you're using a public device, please use caution when entering sensitive or personal information. Always close your browser window and permanently delete any file downloads when finished.",
  "Please read the attached document carefully and sign it.": "Please read the attached document carefully and sign it.",
  "Please read the attached document carefully.": "Please read the attached document carefully.",
  "Please resolve the file upload errors": "Please resolve the file upload errors",
  "Please review your answers below. Click edit to make changes to a section.": "Please review your answers below. Click edit to make changes to a section.",
  "Please select <1>New Patient</1> or <3>Existing Patient</3> to begin.": "Please select <1>New Patient</1> or <3>Existing Patient</3> to begin.",
  "Please sign this document to proceed further.": "Please sign this document to proceed further.",
  "Please upload an image less than 12 MB": "Please upload an image less than 12 MB",
  "Please upload at least {{count}} file(s)_one": "Please upload at least {{count}} file(s)",
  "Please upload at least {{count}} file(s)_other": "Please upload at least {{count}} file(s)",
  "Please wait for uploads to finish": "Please wait for uploads to finish",
  "Postal Code": "Postal Code",
  "Powered by": "Powered by",
  "Pre-Admission Registration Form": "Pre-Admission Registration Form",
  "Preferred Name": "Preferred Name",
  "Previous": "Previous",
  "Privacy Policy": "Privacy Policy",
  "Progress saves automatically": "Progress saves automatically",
  "Province": "Province",
  "Re-sign document": "Re-sign document",
  "Redirecting in {{count}} seconds_one": "Redirecting in {{count}} second",
  "Redirecting in {{count}} seconds_other": "Redirecting in {{count}} seconds",
  "Redirecting to Kiosk in {{count}} seconds_one": "Redirecting to Kiosk in {{count}} second",
  "Redirecting to Kiosk in {{count}} seconds_other": "Redirecting to Kiosk in {{count}} seconds",
  "Relationship to Subscriber": "Relationship to Subscriber",
  "Remove": "Remove",
  "Remove image": "Remove image",
  "Remove signature": "Remove signature",
  "Replace": "Replace",
  "Replace Image": "Replace Image",
  "Resend": "Resend",
  "Resend Code": "Resend Code",
  "Restore saved progress": "Restore saved progress",
  "Restoring your form…": "Restoring your form…",
  "Resume form": "Resume form",
  "Retry": "Retry",
  "Review": "Review",
  "Review your information": "Review your information",
  "SSN must be 9 digits": "SSN must be 9 digits",
  "Save": "Save",
  "Save time by auto-filling your information from past form submissions, or fill out the form manually.": "Save time by auto-filling your information from past form submissions, or fill out the form manually.",
  "Saved progress is available. Restoring it will replace the answers you've entered.": "Saved progress is available. Restoring it will replace the answers you've entered.",
  "Saving the document...": "Saving the document...",
  "Saving…": "Saving…",
  "Search for your bank": "Search for your bank",
  "Search payers...": "Search payers...",
  "Search...": "Search...",
  "Sec": "Sec",
  "Security Code": "Security Code",
  "Select": "Select",
  "Select All": "Select All",
  "Select Form": "Select Form",
  "Select Form to fill": "Select Form to fill",
  "Select Payer Name": "Select Payer Name",
  "Select a previous e-signature to auto-fill.": "Select a previous e-signature to auto-fill.",
  "Select language": "Select language",
  "Select one of the methods below to electronically sign this document": "Select one of the methods below to electronically sign this document",
  "Self": "Self",
  "Sending OTP": "Sending OTP",
  "Signature": "Signature",
  "Signature drawing area": "Signature drawing area",
  "Signature is required": "Signature is required",
  "Signature style": "Signature style",
  "Signature. Drag or use arrow keys to move, plus and minus to resize, Delete to remove.": "Signature. Drag or use arrow keys to move, plus and minus to resize, Delete to remove.",
  "Signature. Press Enter to edit its position.": "Signature. Press Enter to edit its position.",
  "Signed {{timestamp}}": "Signed {{timestamp}}",
  "Signed · {{count}} pages_one": "Signed · {{count}} pages",
  "Signed · {{count}} pages_other": "Signed · {{count}} pages",
  "Some of your recent changes aren't saved yet.": "Some of your recent changes aren't saved yet.",
  "Something went wrong": "Something went wrong",
  "Something went wrong submitting your form. Please try again.": "Something went wrong submitting your form. Please try again.",
  "Spanish": "Spanish",
  "Spouse": "Spouse",
  "Start fresh": "Start fresh",
  "Starting fresh…": "Starting fresh…",
  "State": "State",
  "Stay and save": "Stay and save",
  "Street Address 1": "Street Address 1",
  "Street Address 2": "Street Address 2",
  "Submit": "Submit",
  "Submitting…": "Submitting…",
  "Subscriber Date of Birth": "Subscriber Date of Birth",
  "Subscriber First Name": "Subscriber First Name",
  "Subscriber Last Name": "Subscriber Last Name",
  "Subscriber Member ID": "Subscriber Member ID",
  "Successful submission": "Successful submission",
  "Terms & Conditions": "Terms & Conditions",
  "Terms and Conditions": "Terms and Conditions",
  "Thank you for choosing {{companyName}}. Please take a moment to fill out the required information.": "Thank you for choosing {{companyName}}. Please take a moment to fill out the required information.",
  "Thank you for choosing {{companyName}}. Please take a moment to verify and fill out the required information.": "Thank you for choosing {{companyName}}. Please take a moment to verify and fill out the required information.",
  "Thank you!": "Thank you!",
  "Thank you.": "Thank you.",
  "The document is taking too long to load.": "The document is taking too long to load.",
  "The link you followed is missing some information. Please check the link or contact {{officeName}} for a new one.": "The link you followed is missing some information. Please check the link or contact {{officeName}} for a new one.",
  "There are no results at the time": "There are no results at the time",
  "There is more than one patient registered with this information. Please contact our office to proceed further.": "There is more than one patient registered with this information. Please contact our office to proceed further.",
  "There is no such patient registered with us. Enter the correct information or register as a new patient.": "There is no such patient registered with us. Enter the correct information or register as a new patient.",
  "This document is password protected and cannot be displayed.": "This document is password protected and cannot be displayed.",
  "This document is password protected and cannot be signed.": "This document is password protected and cannot be signed.",
  "This document is too large to sign.": "This document is too large to sign.",
  "This field is required": "This field is required",
  "This form includes a payment section and cannot be accessed via public links. Please contact {{officeName}} to request a unique link.": "This form includes a payment section and cannot be accessed via public links. Please contact {{officeName}} to request a unique link.",
  "This form is no longer available.": "This form is no longer available.",
  "This form link is not valid anymore. If you believe this is an error, please get in touch with our office.": "This form link is not valid anymore. If you believe this is an error, please get in touch with our office.",
  "This form no longer exists.": "This form no longer exists.",
  "This is just a preview of the fields": "This is just a preview of the fields",
  "This link is broken.": "This link is broken.",
  "This page could not be found.": "This page could not be found.",
  "Timer icon": "Timer icon",
  "To auto-fill your form, we need to validate your identity through a verification code.": "To auto-fill your form, we need to validate your identity through a verification code.",
  "To protect your privacy, this download option will time out in 2 minutes.": "To protect your privacy, this download option will time out in 2 minutes.",
  "Too many attempts. Please try again later.": "Too many attempts. Please try again later.",
  "Too many attempts. Please wait before trying again.": "Too many attempts. Please wait before trying again.",
  "Too many files": "Too many files",
  "Try again": "Try again",
  "Type": "Type",
  "Type Your Signature Above": "Type Your Signature Above",
  "US": "US",
  "Unable to Access form": "Unable to Access form",
  "Unable to load last saved ACH details!": "Unable to load last saved ACH details!",
  "Unable to load last saved card details!": "Unable to load last saved card details!",
  "Unable to load the document!": "Unable to load the document!",
  "Unable to render this page. Please try again.": "Unable to render this page. Please try again.",
  "Unable to save the signed document. Please try again.": "Unable to save the signed document. Please try again.",
  "Unavailable": "Unavailable",
  "Unfortunately, we cannot allow downloads beyond the specified time limit to protect your privacy.": "Unfortunately, we cannot allow downloads beyond the specified time limit to protect your privacy.",
  "Update Signature": "Update Signature",
  "Upload": "Upload",
  "Upload Image": "Upload Image",
  "Upload an image of your signature": "Upload an image of your signature",
  "Upload failed": "Upload failed",
  "Upload failed. Please try again.": "Upload failed. Please try again.",
  "Uploaded file": "Uploaded file",
  "Uploaded signature preview": "Uploaded signature preview",
  "Uploading...": "Uploading...",
  "Use signature by {{name}}": "Use signature by {{name}}",
  "Use this previous signature": "Use this previous signature",
  "Verification code sent successfully": "Verification code sent successfully",
  "Verification details are incorrect. Please check and try again.": "Verification details are incorrect. Please check and try again.",
  "Verify & Get Started": "Verify & Get Started",
  "Verify & Proceed": "Verify & Proceed",
  "Verify Identity": "Verify Identity",
  "Verify your identity to resume your saved form.": "Verify your identity to resume your saved form.",
  "Verifying . . .": "Verifying . . .",
  "Verifying…": "Verifying…",
  "We are unable to fetch them right now.": "We are unable to fetch them right now.",
  "We can't fetch your form.": "We can't fetch your form.",
  "We couldn't discard your saved progress. Your draft is still saved. Please try again.": "We couldn't discard your saved progress. Your draft is still saved. Please try again.",
  "We couldn't load your saved progress. Try again.": "We couldn't load your saved progress. Try again.",
  "We couldn't start secure payment setup. Please try again.": "We couldn't start secure payment setup. Please try again.",
  "We couldn't verify your details right now. Please try again.": "We couldn't verify your details right now. Please try again.",
  "We were unable to load this form. Please check your connection and try again.": "We were unable to load this form. Please check your connection and try again.",
  "We've sent a 6 digit code {{emailOrPhone}}": "We've sent a 6 digit code {{emailOrPhone}}",
  "Weave Forms": "Weave Forms",
  "WebOTP failed.": "WebOTP failed.",
  "Welcome": "Welcome",
  "Welcome back": "Welcome back",
  "Welcome, {{firstName}}": "Welcome, {{firstName}}",
  "Work Phone": "Work Phone",
  "Yes": "Yes",
  "Yes: extend my session": "Yes: extend my session",
  "You can download a PDF of the forms that you submitted just now.": "You can download a PDF of the forms that you submitted just now.",
  "You can upload at most {{count}} file(s)_one": "You can upload at most {{count}} file(s)",
  "You can upload at most {{count}} file(s)_other": "You can upload at most {{count}} file(s)",
  "You have unsaved changes": "You have unsaved changes",
  "You have uploaded invalid file. Allowed image types are {{types}}": "You have uploaded invalid file. Allowed image types are {{types}}",
  "You're offline. Recent changes aren't saved.": "You're offline. Recent changes aren't saved.",
  "You're offline. Recent changes aren't saved. They'll save when you reconnect.": "You're offline. Recent changes aren't saved. They'll save when you reconnect.",
  "You've submitted all the forms successfully!": "You've submitted all the forms successfully!",
  "Your ACH details have been submitted successfully. Please proceed to fill and submit the rest of your form.": "Your ACH details have been submitted successfully. Please proceed to fill and submit the rest of your form.",
  "Your card details have been submitted successfully. Please proceed to fill and submit the rest of your form.": "Your card details have been submitted successfully. Please proceed to fill and submit the rest of your form.",
  "Your form has been submitted successfully!": "Your form has been submitted successfully!",
  "Your form has been submitted successfully.": "Your form has been submitted successfully.",
  "Your form's trip is complete.": "Your form's trip is complete.",
  "Your progress is saved as a draft so you can return later. Select Submit when you’re finished so the office receives your information.": "Your progress is saved as a draft so you can return later. Select Submit when you’re finished so the office receives your information.",
  "Your saved answers will be deleted. This cannot be undone.": "Your saved answers will be deleted. This cannot be undone.",
  "Your saved progress has been restored.": "Your saved progress has been restored.",
  "Your saved progress has been restored. Some answers or files could not be restored. Please review and re-enter them.": "Your saved progress has been restored. Some answers or files could not be restored. Please review and re-enter them.",
  "Your saved progress is no longer available. Select Start fresh to fill out the form.": "Your saved progress is no longer available. Select Start fresh to fill out the form.",
  "Your signature": "Your signature",
  "Your verification expired. Please verify again.": "Your verification expired. Please verify again.",
  "ZIP": "ZIP",
  "ZIP Code": "ZIP Code",
  "Zoom": "Zoom",
  "Zoom in": "Zoom in",
  "Zoom out": "Zoom out",
  "broken link image": "broken link image",
  "eSign": "eSign",
  "form does not exist image": "form does not exist image",
  "form expired image": "form expired image",
  "form received image": "form received image",
  "more": "more",
  "scrollDown": "scrollDown",
  "unable to fetch form image": "unable to fetch form image",
  "us": "us",
  "{{accountType}} Account": "{{accountType}} Account",
  "{{count}} pages_one": "{{count}} pages",
  "{{count}} pages_other": "{{count}} pages",
  "{{current}}/{{total}} Pages": "{{current}}/{{total}} Pages",
  "{{types}} up to 12 MB": "{{types}} up to 12 MB",
  "{{type}} side of card": "{{type}} side of card"
}
